import { motion } from "framer-motion";
import { useI18n } from "../../i18n";

const nums = ["01", "02", "03", "04"];

export const Etapes = () => {
  const { t } = useI18n();
  return (
    <section id="approche" className="py-24 lg:py-36 border-t border-white/10" data-testid="etapes-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <p className="font-heading text-gold text-sm tracking-[0.25em] uppercase mb-6">{t("etapes.kicker")}</p>
          <h2 className="font-heading font-bold tracking-tighter text-3xl sm:text-4xl lg:text-5xl max-w-2xl">
            {t("etapes.heading")} <span className="text-gold">{t("etapes.headingGold")}</span>
          </h2>
        </motion.div>

        <div className="border-b border-white/10">
          {t("etapes.steps").map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -28 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="chapter-row grid grid-cols-12 gap-4 py-10 lg:py-14 items-start"
              data-testid={`etape-row-${i}`}
            >
              <div className="col-span-3 lg:col-span-2">
                <span className="font-heading font-bold text-5xl lg:text-7xl outline-text tracking-tighter">{nums[i]}</span>
              </div>
              <div className="col-span-9 lg:col-span-4">
                <h3 className="font-heading font-bold tracking-tight text-2xl lg:text-3xl">{s.title}</h3>
              </div>
              <div className="col-span-12 lg:col-span-6">
                <p className="text-[#8A9DB1] leading-relaxed text-base md:text-lg max-w-xl">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Etapes;
